import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getInvoiceList, invoiceFuyouVoid, invoiceFuyouQuery, invoiceRedo } from '@/api/bairun/invoice';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import vueQr from 'vue-qr';
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import { store } from '@/store';

var _this;

export default {
  name: 'OrderInvoice',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatMoney: function formatMoney(v) {
      if (v == null || v === '') {
        return '';
      }

      return '¥' + Number(v).toFixed(2);
    }
  },
  mixins: [infoList],
  components: {
    SearchTerm: SearchTerm,
    vueQr: vueQr
  },
  computed: _objectSpread({}, mapGetters('stations', ['allStationMap'])),
  watch: {
    'redoForm.invoiceType': function redoFormInvoiceType(val) {
      var _this2 = this;

      // 选个人票时税号栏隐藏，顺带清掉已填的值和校验提示
      if (val == 1) {
        this.redoForm.buyerTaxNo = '';
        this.$nextTick(function () {
          _this2.$refs.redoForm && _this2.$refs.redoForm.clearValidate('buyerTaxNo');
        });
      }
    }
  },
  data: function data() {
    var _this3 = this;

    return {
      listApi: getInvoiceList,
      loading: false,
      searchInfo: {
        // 按配置顺序显示
        'timeStart': '',
        'timeEnd': '',
        'stationId': '',
        'mainOrderNo': '',
        'mobile': ''
      },
      invoicePreviewVisible: false,
      invoicePreviewLoading: false,
      invoicePreviewSrc: '',
      //预览用的 blob 地址，关框要释放
      invoicePreviewBlob: null,
      //预览取回来的 pdf，下载按钮直接复用
      invoicePreviewRow: null,
      //当前预览的列表行，下载时取单号做文件名
      qrcodeDialogVisible: false,
      qrcodeText: '',
      //二维码内容：列表行的换开h5地址
      bairunLogo: require('@/assets/bairun-logo.jpg'),
      //二维码中间的logo
      redoDialogVisible: false,
      redoSubmitting: false,
      redoForm: {
        invoiceType: 2,
        mainOrderNo: '',
        buyerName: '',
        buyerTaxNo: '',
        remarks: '',
        mobile: '',
        email: ''
      },
      redoRules: {
        mainOrderNo: [{
          required: true,
          message: '请输入订单号',
          trigger: 'blur'
        }],
        buyerName: [{
          required: true,
          message: '请输入发票抬头',
          trigger: 'blur'
        }],
        buyerTaxNo: [// 只有公司票才校税号，个人票这栏是隐藏的
        {
          required: true,
          validator: function validator(rule, value, callback) {
            if (_this3.redoForm.invoiceType == 2 && !value) {
              callback(new Error('请输入税号'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '手机号格式不正确',
          trigger: 'blur'
        }],
        email: [{
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: '邮箱格式不正确',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this4.init();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  deactivated: function deactivated() {
    // 使用keepalive的页面，离开时把预览关掉，别让pdf的blob一直挂在内存里
    this.invoicePreviewVisible = false;
    this.onInvoicePreviewClose();
  },
  methods: {
    init: function init() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onSearch: function onSearch() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.page = 1;
                _this5.pageSize = 10;
                _this5.loading = true;
                _context3.next = 5;
                return _this5.getTableData();

              case 5:
                _this5.loading = false;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    isRedInvoice: function isRedInvoice(row) {
      return Number(row.totalAmount) < 0;
    },
    isBlueInvoice: function isBlueInvoice(row) {
      return row.status == 4;
    },
    isNormalInvoice: function isNormalInvoice(row) {
      return !this.isRedInvoice(row) && !this.isBlueInvoice(row);
    },
    statusText: function statusText(row) {
      if (this.isRedInvoice(row)) {
        var _map = {
          0: '待处理',
          1: '红冲中',
          2: '红冲成功',
          3: '红冲失败'
        };
        return _map[row.status] != null ? _map[row.status] : row.status;
      }

      if (this.isBlueInvoice(row)) {
        return '被红冲';
      }

      var map = {
        0: '待开票',
        1: '开票中',
        2: '开票成功',
        3: '开票失败'
      };
      return map[row.status] != null ? map[row.status] : row.status;
    },
    statusTagType: function statusTagType(row) {
      if (this.isRedInvoice(row)) {
        return 'danger';
      }

      if (this.isBlueInvoice(row)) {
        return '';
      } //正常发票：开票失败挂红标签，其余还是绿标签


      if (row.status == 3) {
        return 'danger';
      }

      if (row.status == 0) {
        return 'info';
      }

      return 'success';
    },
    invoiceTypeText: function invoiceTypeText(row) {
      if (this.isRedInvoice(row)) {
        return '红字发票';
      }

      if (this.isBlueInvoice(row)) {
        return '蓝字发票';
      }

      return '正常发票';
    },
    invoiceTypeTag: function invoiceTypeTag(row) {
      if (this.isRedInvoice(row)) {
        return 'danger';
      }

      if (this.isBlueInvoice(row)) {
        return '';
      }

      return 'success';
    },
    onVoid: function onVoid(row) {
      var _this6 = this;

      this.$confirm("\u786E\u5B9A\u5BF9\u8BA2\u5355\u3010".concat(row.mainOrderNo, "\u3011\u8FDB\u884C\u53D1\u7968\u51B2\u7EA2\u64CD\u4F5C\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return invoiceFuyouVoid({
                  'mainOrderNo': row.mainOrderNo
                });

              case 2:
                res = _context4.sent;

                if (res.code === 0) {
                  _this6.$message({
                    type: 'success',
                    message: '冲红成功'
                  });

                  _this6.onSearch();
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))).catch(function () {});
    },
    //打开换开弹框：没有列表行可取值，订单号由填表的人自己给
    onRedoDialog: function onRedoDialog() {
      this.redoForm = {
        invoiceType: 2,
        mainOrderNo: '',
        buyerName: '',
        buyerTaxNo: '',
        remarks: '',
        mobile: '',
        email: ''
      };
      this.redoDialogVisible = true;
    },
    onRedoDialogClose: function onRedoDialogClose() {
      this.$refs.redoForm && this.$refs.redoForm.clearValidate();
    },
    //二维码弹框：内容取列表行的换开h5地址，扫出来直接进小程序的换开页
    onShowQrcode: function onShowQrcode(row) {
      if (!row || !row.scanQrUrl) {
        return;
      }

      this.qrcodeText = row.scanQrUrl;
      this.qrcodeDialogVisible = true;
    },
    onQrcodeDialogClose: function onQrcodeDialogClose() {
      this.qrcodeText = '';
    },
    confirmRedo: function confirmRedo() {
      var _this7 = this;

      if (this.redoSubmitting) {
        return;
      }

      this.$refs.redoForm.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
          var payload, res, data, status;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (valid) {
                    _context5.next = 2;
                    break;
                  }

                  return _context5.abrupt("return", false);

                case 2:
                  _this7.redoSubmitting = true;
                  _context5.prev = 3;
                  payload = _objectSpread({}, _this7.redoForm); // 个人票不带税号，提交前再兜底清一次

                  if (Number(payload.invoiceType) === 1) {
                    payload.buyerTaxNo = '';
                  }

                  _context5.next = 8;
                  return invoiceRedo(payload);

                case 8:
                  res = _context5.sent;

                  if (!(!res || res.code !== 0)) {
                    _context5.next = 12;
                    break;
                  }

                  _this7.$message({
                    type: 'error',
                    message: String(res && res.msg || '换开失败').replace(/^失败,/, '')
                  });

                  return _context5.abrupt("return");

                case 12:
                  data = res.data || {};
                  status = Number(data.status);

                  if (status === 1) {
                    _this7.$message({
                      type: 'success',
                      message: '换开成功'
                    });
                  } else if (status === 0) {
                    _this7.$message({
                      type: 'warning',
                      message: '换开处理中，请稍后刷新查看'
                    });
                  } else {
                    _this7.$message({
                      type: 'error',
                      message: data.message || '换开失败'
                    });
                  }

                  _this7.redoDialogVisible = false;

                  _this7.onSearch();

                  _context5.next = 23;
                  break;

                case 19:
                  _context5.prev = 19;
                  _context5.t0 = _context5["catch"](3);
                  console.error('换开发票失败', _context5.t0);

                  _this7.$message({
                    type: 'error',
                    message: '换开发票失败，请稍后重试'
                  });

                case 23:
                  _context5.prev = 23;
                  _this7.redoSubmitting = false;
                  return _context5.finish(23);

                case 26:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[3, 19, 23, 26]]);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    onRefresh: function onRefresh(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.loading = true;
                _context6.next = 3;
                return invoiceFuyouQuery({
                  'mainOrderNo': row.mainOrderNo
                });

              case 3:
                res = _context6.sent;

                if (!(res.code === 0)) {
                  _context6.next = 9;
                  break;
                }

                _context6.next = 7;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 7:
                _context6.next = 9;
                return _this8.getTableData();

              case 9:
                _this8.loading = false;

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    //取发票pdf：走后台代理接口，避开富友那边的跨域和 Content-Disposition
    //不走 @/utils/request 的 service 实例：它的响应拦截器按 JSON 读 response.data.code，拿到 blob 会当失败处理
    fetchInvoiceBlob: function fetchInvoiceBlob(pdfUrl) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var url, resp;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = "".concat(process.env.VUE_APP_BASE_API, "/orderManage/invoice/v1/fuyou/proxyPdf?url=").concat(encodeURIComponent(pdfUrl));
                _context7.next = 3;
                return axios.get(url, {
                  responseType: 'blob',
                  timeout: 30000,
                  headers: {
                    'x-token': store.getters['user/token'],
                    'x-user-id': store.getters['user/userInfo'].ID
                  }
                });

              case 3:
                resp = _context7.sent;
                return _context7.abrupt("return", resp.data);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    //查看发票：先把pdf拉回来，再在弹框里预览，下载按钮复用同一份数据
    onPreviewInvoice: function onPreviewInvoice(row) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var pdfUrl;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                pdfUrl = row.pdfUrl;

                if (pdfUrl) {
                  _context8.next = 4;
                  break;
                }

                _this9.$message({
                  type: 'warning',
                  message: '未获取到发票文件地址'
                });

                return _context8.abrupt("return");

              case 4:
                _this9.invoicePreviewRow = row;
                _this9.invoicePreviewVisible = true;
                _this9.invoicePreviewLoading = true;

                _this9.clearInvoicePreviewSrc();

                _context8.prev = 8;
                _context8.next = 11;
                return _this9.fetchInvoiceBlob(pdfUrl);

              case 11:
                _this9.invoicePreviewBlob = _context8.sent;
                _this9.invoicePreviewSrc = window.URL.createObjectURL(_this9.invoicePreviewBlob);
                _context8.next = 19;
                break;

              case 15:
                _context8.prev = 15;
                _context8.t0 = _context8["catch"](8);
                console.error('发票预览失败', _context8.t0);

                _this9.$message({
                  type: 'error',
                  message: '发票加载失败，请稍后重试'
                });

              case 19:
                _context8.prev = 19;
                _this9.invoicePreviewLoading = false;
                return _context8.finish(19);

              case 22:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[8, 15, 19, 22]]);
      }))();
    },
    //下载发票：保存预览已经取回来的blob，不再请求一次
    onDownloadInvoice: function onDownloadInvoice() {
      if (!this.invoicePreviewBlob) {
        return;
      }

      var name = (this.invoicePreviewRow && this.invoicePreviewRow.mainOrderNo || 'invoice') + '.pdf';
      saveAs(this.invoicePreviewBlob, name);
    },
    //关框时释放 blob 地址，否则每看一次都留一份内存
    onInvoicePreviewClose: function onInvoicePreviewClose() {
      this.clearInvoicePreviewSrc();
      this.invoicePreviewBlob = null;
      this.invoicePreviewRow = null;
    },
    clearInvoicePreviewSrc: function clearInvoicePreviewSrc() {
      if (this.invoicePreviewSrc) {
        window.URL.revokeObjectURL(this.invoicePreviewSrc);
        this.invoicePreviewSrc = '';
      }
    }
  }
};